// Modules
import { ChangeEvent } from 'react'
import { useFormik } from 'formik'
import { formatCPF } from '@brazilian-utils/brazilian-utils'

// Application
import { UserLoginWithLink } from 'redesign/validators'
import { useAuthentication } from 'redesign/hooks/useAuthentication'
import { useRemoteConfig } from 'modules/RemoteConfig/hooks/useRemoteConfig'
import { useSignUpAnaytics } from 'hooks/useSignUpAnaytics'
import { federalTaxIdValidator } from 'utils'

type GeolocationPositionType = {
    coords: {
        latitude: number | null
        longitude: number | null
    }
}

export const useLinkLoginForm = () => {
    const { isFeatureEnabled } = useRemoteConfig()
    const { handleLinkAuthUser } = useAuthentication()

    const { dispatchAnalyticsEventFeedBack } = useSignUpAnaytics()

    const initialValues = {
        cpf: '',
        id: '',
    }

    const form = useFormik({
        initialValues,
        validationSchema: UserLoginWithLink,
        onSubmit: async (formValues, { setFieldError, setSubmitting, setFieldValue, setTouched }) =>
            handleLinkAuthUser({ ...formValues, setFieldError, setSubmitting, setFieldValue, setTouched }),
    })

    const handleChangeCpf = (event: ChangeEvent<HTMLInputElement>) => {
        const currentValue = event.target.value.replace(/\./g, '').replace(/-/g, '')
        event.target.value = formatCPF(currentValue)
        form.handleChange(event)
        if (currentValue.length === 4) {
            dispatchAnalyticsEventFeedBack('confirmCpf', { errorMessage: 'Interagiu com campo CPF' })
        }
        if (currentValue.length === 11 && !federalTaxIdValidator(event.target.value)) {
            dispatchAnalyticsEventFeedBack('confirmCpf')
        }
    }

    const isAuthServiceDown = () => {
        const isServiceDown = isFeatureEnabled('AUTH_SERVICE_DOWN')

        return { isServiceDown }
    }

    return {
        ...form,
        isServiceDown: isAuthServiceDown().isServiceDown,
        handleChangeCpf,
        isAuthServiceDown,
    }
}
